import { emit, events } from '@estee/elc-service-bus';
import { Config } from '~domain/entities/Config';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export class ShowMapClickedUseCase {
    private config: Config;

    constructor() {
        this.config = diContainer.get(serviceNames.config);
    }

    public execute() {
        const {
            config: { home_path }
        } = this.config;
        emit(events.CHANGE_LOCATION, { redirectUrl: `/${home_path}` });
    }
}
